import { render } from "./_Partners.vue?vue&type=template&id=5e2ad50a&scoped=true&lang=en"
import script from "./_Partners.vue?vue&type=script&lang=js"
export * from "./_Partners.vue?vue&type=script&lang=js"

import "./_Partners.vue?vue&type=style&index=0&id=5e2ad50a&lang=scss&scoped=true"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2ad50a"]])

export default __exports__